import { Container, Box, Stack, CircularProgress, Typography } from "@mui/material";
import { colors } from "../../../ui/colors";

interface CustomLoaderProps {
  message?: string;
  minHeight?: string | number;
  size?: number;
}

export const CustomLoader = ({
  message = "Loading...",
  minHeight = "60vh",
  size = 60,
}: CustomLoaderProps) => {
  return (
    <Container maxWidth="lg">
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={minHeight}>
        <Stack alignItems="center" spacing={3}>
          <CircularProgress
            size={size}
            thickness={4}
            sx={{
              color: colors.orange.base,
              "& .MuiCircularProgress-circle": { strokeLinecap: "round" },
            }}
          />

          <Typography variant="h6" fontWeight={600} color={colors.orange.base}>
            {message}
          </Typography>
        </Stack>
      </Box>
    </Container>
  );
};
